import React from 'react'
import { MDBBtn } from 'mdb-react-ui-kit'

const EventLog = ({ events, onClear, onExport }) => {
  return (
    <div className='ws-card'>
      <h5 className='d-flex justify-content-between align-items-center'>
        <span>Event Log ({events.length})</span>
        <span>
          <MDBBtn type='button' size='sm' color='secondary' onClick={onClear} className='mr-2'>
            Clear
          </MDBBtn>
          <MDBBtn type='button' size='sm' color='info' onClick={onExport} disabled={events.length === 0}>
            Export JSON
          </MDBBtn>
        </span>
      </h5>
      <div className='ws-event-log'>
        {events.length === 0 && (
          <div className='text-muted'>No events yet. Subscribe to a channel and trigger a broadcast.</div>
        )}
        {events.map(e => (
          <div key={e.id} className='ws-event-row'>
            <div>
              <span className='ws-event-meta'>{e.ts}</span> <span className='ws-event-channel'>{e.channel}</span>{' '}
              <span className='ws-event-meta'>→ {e.event}</span>
            </div>
            <div className='ws-event-payload'>{JSON.stringify(e.payload, null, 2)}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default EventLog
